import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import { AppInitWrapper } from 'src/hocs/AppInitWrapper';

document.addEventListener('DOMContentLoaded', () => {
	const container = document.querySelector('#app');
	const root = createRoot(container!);
	root.render(
		<AppInitWrapper>
			<HashRouter>
				<App />
			</HashRouter>
		</AppInitWrapper>
	);
});
